<template>
  <div style="width: 500px;">
  </div>
  <page-header />
  <div style="padding: 30px">
    <template v-for="(item, key) in toolBoards">
      <template v-if="item.type === 'link'">
        <a :href="item.uri" class="item">
          <a-card :title="item.title" hoverable class="card">
            <p v-for="cp in item.content">{{cp}}</p>
          </a-card>
        </a>
      </template>
      <template v-else>
        <router-link :to="item.uri" class="item">
          <a-card :title="item.title" hoverable class="card">
            <p v-for="cp in item.content">{{cp}}</p>
          </a-card>
        </router-link>
      </template>
    </template>
    <div class="clear"></div>
  </div>
  <div class="footer"><icp></icp></div>
</template>

<script>
import {message} from 'ant-design-vue'
import Icp from '@/components/icp'
import PageHeader from '@/components/header'
import request from '@/utils/request'
import {defineComponent, ref} from "vue";

export default defineComponent({
  components: {
    Icp,
    PageHeader
  },
  setup() {
    const toolBoards = ref([])
    const fetchPCHomeScene = async () => {
      try {
        const response = await request.get('/site/scene/pc_home')
        const data = response.data
        toolBoards.value = data.tool_boards || []
      } catch (error) {
        message.error('获取列表数据失败')
        console.error(error)
      }
    }
    fetchPCHomeScene()

    return {
      toolBoards
    }
  }
})
</script>
<style scoped>
.item {
  float:left;
  margin-right: 30px;
}
.card {
  width: 300px;
}
.clear {
  clear: both;
}
.footer {
  text-align: center;
}
</style>


